<template>
  <div class="card">
    <Toast />
    <div class="title">Temporary Omset</div>
    <div class="p-grid p-fluid p-mb-2">
      <div class="p-col-4">
        <Calendar
          v-model="audit_date"
          :showIcon="true"
          dateFormat="yy-mm-dd"
          placeholder="Audit Date"
          :selectOtherMonths="true"
          :showButtonBar="true"
        />
      </div>
      <div class="p-col">
        <Button
          label="Cari"
          class="p-button-info"
          @click="getTemporaryOmset()"
          v-shortkey.push="['enter']"
          @shortkey="getTemporaryOmset()"
        />
      </div>

      <div class="p-col">
        <div v-if="temporary_omset.length > 0">
          <Button
            label="Sync-revenue"
            class="p-button-primary"
            @click="syncRevenueOpen()"
          />
        </div>
      </div>

      <table
        class="table table-responsive"
        style="font-size: 16px"
        v-if="temporary_omset.length > 0"
      >
        <thead class="thead-light">
          <tr>
            <th>Metode Pembayaran</th>
            <th>Jumlah</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(an_item, k) in temporary_omset" :key="k">
            <td>
              <h5>{{ an_item.name_payment }}</h5>
            </td>
            <td>
              {{ an_item.total_payment | currency }}
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <Dialog
          :visible.sync="syncRevenueDialog"
          :style="{ width: '500px' }"
          :modal="true"
          :closable="false"
          header="Konfirmasi"
        >
          <div class="confirmation-content">
            <span>
              <b>Apakah anda yakin ingin sync-revenue omset ini?</b>
            </span>
          </div>
          <template #footer>
            <Button
              label="Tidak"
              icon="pi pi-times"
              class="p-button-text"
              @click="syncRevenueDialog = false"
            />
            <Button
              label="Ya"
              icon="pi pi-check"
              class="p-button-text"
              @click="syncRevenue()"
            />
          </template>
        </Dialog>
      </div>
    </div>

    <div class="p-grid p-fluid p-col">
      <table style="font-size: 18px">
        <th></th>
        <tbody>
          <tr>
            <td>
              <h4
                style="margin-right: 1rem; font-size: 18px; margin-bottom: 1rem"
              >
                Total Omset :
              </h4>
            </td>
            <td>{{ total_omset | currency }}</td>
          </tr>
        </tbody>
        <Button
          v-if="total_omset != 0"
          label="Temporary Print"
          icon="pi pi-print"
          class="p-button-rounded p-button-info"
          @click="printTemporaryOmset()"
        />
        <Button
          v-if="total_omset != 0"
          label="Jurnal Cashier"
          icon="pi pi-print"
          style="margin-top: 10px"
          class="p-button-rounded p-button-success"
          @click="printJurnalCashier()"
        />
      </table>
      <Dialog
        :visible.sync="confirmDialog"
        :style="{ width: '450px' }"
        header="Pemberitahuan"
        :modal="true"
        :closable="false"
      >
        <div class="confirmation-content">
          <i class="pi pi-print p-mr-3" style="font-size: 2rem" />
          <span> Print... </span>
        </div>
        <template #footer>
          <Button
            label="Close"
            icon="pi pi-check"
            class="p-button-text"
            @click="closeDialog()"
            v-shortkey.push="['enter']"
            @shortkey="closeDialog()"
          />
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
var moment = require('moment')
import VueNativeSock from 'vue-native-websocket'
import Vue from 'vue'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  watch: {
    user() {
      this.getAuthUser()
    }
  },
  data() {
    return {
      moment: moment,
      omset_date: null,
      temporary_omset: null,
      total_omset: null,
      confirmDialog: false,
      syncRevenueDialog: false,
      payment_method: null,
      today: new Date().toISOString().split('T')[0],
      audit_date: null
    }
  },
  mounted() {
    this.getAuthUser()
    this.getTemporaryOmset()
    if (process.env.VUE_APP_ENABLE_PRINTER) {
      this.initWS()
    }
  },
  methods: {
    initWS() {
      //enable websocket
      console.info('Enable websocket printer')
      Vue.use(VueNativeSock, process.env.VUE_APP_PRINTER_URL, {
        reconnection: true, // (Boolean) whether to reconnect automatically (false)
        reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
        reconnectionDelay: 3000 // (Number) how long to initially wait before attempting a new (1000)
      })
    },
    getAuthUser() {
      console.info(this.user)
      this.audit_date = this.today
    },

    async getTemporaryOmset() {
      let audit_date = this.audit_date
        ? moment(this.audit_date).format('YYYY-MM-DD')
        : this.today

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/pos/omset/${audit_date}`
        )

        if (response.status === 200) {
          this.omset_date = response.data.omset_date
          this.temporary_omset = response.data.data.payment
          this.total_omset = response.data.data.total_omset.total
        }
      } catch (error) {
        console.error('Error fetching temporary omset:', error)
      }
    },

    syncRevenueOpen() {
      this.syncRevenueDialog = true
    },

    async syncRevenue() {
      let audit_date = this.audit_date
        ? moment(this.audit_date).format('YYYY-MM-DD')
        : this.today

      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/dashboard/sync-revenue/${audit_date}`
        )

        if (response.status === 200) {
          this.showToast('success', 'Berhasil Sync Revenue')
        } else {
          this.showToast('error', 'Error', 'Gagal Sync Revenue')
        }
      } catch (error) {
        this.showToast('error', 'Error', 'Gagal Sync Revenue')
        console.error('Error syncing revenue:', error)
      } finally {
        this.syncRevenueDialog = false
      }
    },

    printTemporaryOmset() {
      let audit_date = this.audit_date
        ? moment(this.audit_date).format('YYYY-MM-DD')
        : this.today

      this.$http
        .get(`${process.env.VUE_APP_API_URL}/pos/print/omset/${audit_date}`)
        .then(response => {
          if (response.status === 200) {
            this.receiptAPI = response.data.data.print_omset
            this.$socket.send(this.receiptAPI)
            setTimeout(() => {
              this.confirmDialog = true
            }, 1000)
          } else {
            console.error('gagal get history-receipt')
          }
        })
        .catch(error => {
          console.error(error)
          this.showToast('error', 'Error', 'Gagal mengambil data')
        })
    },

    printJurnalCashier() {
      let audit_date = this.audit_date
        ? moment(this.audit_date).format('YYYY-MM-DD')
        : this.today

      this.$http
        .get(`${process.env.VUE_APP_API_URL}/gross-profit/${audit_date}`)
        .then(response => {
          if (response.status === 200) {
            this.receiptAPI = response.data.data.gross_profit
            this.$socket.send(this.receiptAPI)
            setTimeout(() => {
              this.confirmDialog = true
            }, 1000)
          } else {
            console.error('gagal get history-receipt')
          }
        })
        .catch(error => {
          console.error(error)
          this.showToast('error', 'Error', 'Gagal mengambil data')
        })
    },

    closeDialog() {
      this.confirmDialog = false
    }
  }
}
</script>

<style scoped lang="scss">
h5 {
  font-size: 16px;
}
</style>
